import tingle from 'tingle.js';
import modalSwiper from "./swiper.js";

var debug = true;

if (debug) {
  console.log(tingle);
}

//TODO: look at https://js.libhunt.com/baguettebox-js-alternatives as alternative
// webpack lazy loading!!! https://dev.to/brsjsk/lazy-loading-modules-with-webpack-4emg

const openiFrameModal = (embedCode, title) => {
  if (debug) {
    console.log("openiFrameModal");
  }

  var iframe;

  var modaliFrame = new tingle.modal({
    cssClass: ["iframe-modal"],
    onClose: function () {
      modaliFrame.destroy();
    },
  });

  if (embedCode) {
    iframe = `<div class="video-wrapper">` +
                `<iframe width="560" height="315"` +
                    `src="` + embedCode + `"` +
                    `title="YouTube video player"` +
                    `allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>` +
                `</iframe>` +
              `</div>`;
  }
  modaliFrame.setContent(iframe);
  modaliFrame.open();
};

const openGalleryModal = (image, caption) => {
  var modalGallery = new tingle.modal({
    cssClass: ["gallery-modal"],
    onClose: function () {
      modalGallery.destroy();
    },
  });

  var _caption =
    caption != ""
      ? '<figcaption class="gallery-card__caption caption--modal">' +
        caption +
        "</figcaption>"
      : "";
  var figure =
    `<figure class="image-wrap image-wrap--gallery gallery--modal">` +
    `<image src="` +
    image +
    `"> ` +
    _caption +
    `</figure>`;
  modalGallery.setContent(figure);
  modalGallery.open();
};

/**
 * Open entire slider in modal
 *
 * @param {string} - ID of gallery to open in modal
 * @param {int} - index of active slide (start modal slider in position of clicked parent gallery)
 **/
const openSliderInModal = (id, index) => {
  // forEach index starts at 1 whilst PHP count starts at 0
  // correct id of gallery to open will be id - 1
  id = parseInt(id);
  id--;
  index = parseInt(index);
  index--;

  var modalGallery = new tingle.modal({
    cssClass: ["gallery-modal"],
    onClose: function () {
      modalGallery.destroy();
    },
  });

  let entireSlider = document.querySelector(
    ".swiper-panel__cards--inner--" + id
  );
  let entireSliderCloned = entireSlider.cloneNode(true);
  let entireSliderClonedInner = entireSliderCloned.innerHTML;
  // Find activeIndex of cloned slider

  //
  let entireSliderClonedWrapped =
    '<div class="swiper-modal">' + entireSliderClonedInner + "</div>";

  modalGallery.setContent(entireSliderClonedWrapped);
  // Change the cloned markup

  modalSwiper(index);

  modalGallery.open();
};

var videoModalBtns = Array.from(
  document.querySelectorAll(".video-link__modal")
);

videoModalBtns.forEach((videoModalBtn) => {
  videoModalBtn.addEventListener("click", () => {
    let url = videoModalBtn.getAttribute("data-target");
    let title = videoModalBtn.getAttribute("data-title");
    openiFrameModal(url, title);
  });
});

var galleryModalBtns = Array.from(
  document.querySelectorAll(".js-gallery-card-modal")
);

galleryModalBtns.forEach((galleryModalBtn) => {
  galleryModalBtn.addEventListener("click", (e) => {
    e.preventDefault();
    let galleryId = galleryModalBtn.getAttribute("data-gallery");
    let slideIndex = galleryModalBtn.getAttribute("data-index");
    //openGalleryModal(image, caption);
    openSliderInModal(galleryId, slideIndex);
  });
});
